import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { BeneficiariesFilterTemplatesRoutes } from '@repo/shared/routes-beneficiary-filters'
import { AxiosInstance } from 'axios'

import { IFilterTemplatesApi } from '@/spi/api/filter-templates'

export const buildFilterTemplatesApi = (axios: AxiosInstance): IFilterTemplatesApi => ({
  getAll: async ({ organizationId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof BeneficiariesFilterTemplatesRoutes.getAll.response>(
        BeneficiariesFilterTemplatesRoutes.getAll.getPath({ organizationId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  createOne: async ({ organizationId, caseWorkerId, fields }) => {
    const response = await tryCatch(async () =>
      axios.post<typeof BeneficiariesFilterTemplatesRoutes.createOne.response>(
        BeneficiariesFilterTemplatesRoutes.createOne.getPath({ organizationId, caseWorkerId }),
        { payload: fields } satisfies typeof BeneficiariesFilterTemplatesRoutes.createOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  deleteOne: async ({ organizationId, caseWorkerId, filterTemplateId }) => {
    const response = await tryCatch(async () =>
      axios.delete<typeof BeneficiariesFilterTemplatesRoutes.deleteOne.response>(
        BeneficiariesFilterTemplatesRoutes.deleteOne.getPath({
          organizationId,
          caseWorkerId,
          filterTemplateId,
        }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  updateOne: async ({ organizationId, caseWorkerId, filterTemplateId, fields }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof BeneficiariesFilterTemplatesRoutes.updateOne.response>(
        BeneficiariesFilterTemplatesRoutes.updateOne.getPath({
          organizationId,
          caseWorkerId,
          filterTemplateId,
        }),
        { payload: fields } satisfies typeof BeneficiariesFilterTemplatesRoutes.updateOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },
})
